













































































































import { Component, Prop, Vue } from "vue-property-decorator";
import Purchase from "../../../usecases/orders/purchase";
import PurchaseApi from "../../../api/orders/purchase-api";
import VIconEdit from "../../../components/icons/VIconEdit.vue";
import VIconPrint from "../../../components/icons/VIconPrint.vue";
import { client } from "@/api/request";
import VToolbar from "../../common/components/VToolbar.vue";
import VSearchBar from "../../../components/VSearchBar.vue";
import PrintApi from "../../../api/orders/print-api";
import PurchaseService from "../../../usecases/orders/purchase-service";
import PurchaseStatus from "../components/PurchaseStatus.vue";
import PurchaseSearchBar from "@/ui/common/components/InvoiceSearchBar.vue";
import PurchaseSearchOptions from "@/ui/common/presenters/invoice-search-options";
import SelectOption from "@/common/ui/presenters/select-option";
import { getAllProjects } from "@/api/project-api";
import { getAllCompanies } from "@/api/company-api";
import { getUserAriseServices, ServiceArise } from "@/api/service-api";
import ProjectOrderTabs from "@/components/ProjectOrderTabs.vue";
import Status from "@/usecases/orders/purchase-status";

const purchaseApi = new PurchaseApi(client);
const purchaseService = new PurchaseService(purchaseApi);
const printApi = new PrintApi(client);

@Component({
  components: {
    ProjectOrderTabs,
    PurchaseStatus,
    VToolbar,
    VSearchBar,
    VIconEdit,
    VIconPrint,
    PurchaseSearchBar
  }
})
export default class PurchaseListPage extends Vue {
  @Prop() projectId?: string;
  @Prop({ type: Boolean }) edition!: boolean;
  readonly Status = Status;
  purchaseItems: Purchase[] = [];
  printStatus: boolean[] = [];
  isAllSelected: boolean = false;
  selectedIds: number[] = [];
  projects: SelectOption[] = [];
  companies: SelectOption[] = [];
  startDate = "";
  endDate = "";
  selectProject = "";
  resetLoadInfinite = 0;
  edit(id: number) {
    this.$router.push({
      name: "order-purchase-edit",
      params: {
        id: String(id)
      }
    });
  }
  statusOptions = [
    {
      text: "全て(ステータス)",
      value: ""
    },
    {
      text: "未発注",
      value: "created"
    },
    {
      text: "発注済み",
      value: "ordered"
    },
    {
      text: "送金済み",
      value: "paid"
    }
  ];

  roles: ServiceArise[] = [];

  searchOptions: PurchaseSearchOptions = {
    project: "",
    company: "",
    status: "",
    startDate: "",
    endDate: ""
  };

  // 検索: PurchaseSearchBar から
  search() {
    // const options = { projectName };
    this.initServiceRoles();
    this.initProjectList();
    this.initCompanyList();
    this.initPurchaseList(this.searchOptions);
  }

  // ステータス変更
  async changeStatus(id: string, status: string) {
    try {
      await purchaseService.changeStatus(id, status);
    } catch (error) {
      alert(error[0]);
    }
    await this.initServiceRoles();
    await this.initPurchaseList(this.searchOptions);
    await this.$store.dispatch("setProjectEstimateExpenseSummary");
  }

  get service() {
    return this.$store.state.service;
  }

  protected created() {
    this.initServiceRoles();
    this.initProjectList();
    this.initCompanyList();
    // this.initPurchaseList(); // 初回も自動ロードされる
  }

  get projectOptions() {
    return [
      {
        text: "全て(現場)",
        value: ""
      },
      ...this.projects.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initProjectList() {
    this.projects = (await getAllProjects()).map(p => ({
      text: p.name,
      value: String(p.projectId)
    }));
  }

  get companyOptions() {
    return [
      {
        text: "全て(元請け)",
        value: ""
      },
      ...this.companies.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initCompanyList() {
    this.companies = (await getAllCompanies()).map(p => ({
      text: p.name,
      value: String(p.companyId)
    }));
  }

  async createPdf(id: number, index: number, printsExcludeTax: boolean) {
    if (!this.printStatus.includes(true)) {
      this.$set(this.printStatus, index, true);
      const url = await printApi.getPurchasePrint(
        id,
        this.$store.state.accessToken,
        printsExcludeTax
      );
      this.$set(this.printStatus, index, false);
      window.open(url, "発注書印刷");
    } else {
      alert(
        "現在他の発注書で印刷を生成中です。時間をおいてからもう一度試してください。"
      );
    }
  }

  async createAllPdf(id: number, index: number, printsExcludeTax: boolean) {
    if (!this.printStatus.includes(true)) {
      this.$set(this.printStatus, index, true);
      const url = await printApi.getPurchaseAllPrint(
        this.selectedIds,
        this.$store.state.accessToken,
        printsExcludeTax,
        this.searchOptions.project,
        this.searchOptions.company
      );
      this.$set(this.printStatus, index, false);
      window.open(url, "発注書印刷");
      // TODO: 動作がダメそう
      await this.initPurchaseList(this.searchOptions);
    } else {
      alert(
        "現在他の発注書で印刷を生成中です。時間をおいてからもう一度試してください。"
      );
    }
  }

  private async initServiceRoles() {
    this.roles = await getUserAriseServices();
  }

  currentOptions(options: PurchaseSearchOptions = {}, currentLength: number) {
    if (this.searchOptions.project) {
      this.selectProject = this.searchOptions.project;
    } else if (this.projectId) {
      this.selectProject = this.projectId;
    } else {
      this.selectProject = "";
    }
    return {
      ...options,
      projectId: this.selectProject,
      companyId: this.searchOptions.company,
      status: this.searchOptions.status,
      startDate: this.searchOptions.startDate,
      endDate: this.searchOptions.endDate,
      purchaseCount: currentLength
    };
  }

  async getPurchaseList30(options?: any) {
    // 現在の件数は、内容を表示している purchaseItems から直接取得
    const new_options = this.currentOptions(options, this.purchaseItems.length);
    return await purchaseApi.findAll(new_options);
  }

  // 初期化を区別
  // TODO: 30件以降のステータスを変更すると、30件以降がロードされない
  private async initPurchaseList(options?: any) {
    this.selectedIds = []; // セレクトリセット
    this.resetLoadInfinite += 1; // リロードリセット
    const new_options = this.currentOptions(options, 0); // 取得開始を0件に
    console.log("this.resetLoadInfinite", this.resetLoadInfinite);
    this.purchaseItems = await purchaseApi.findAll(new_options);
    for (let i = 0; i < this.purchaseItems.length; i++) {
      this.printStatus.push(false);
    }
  }

  /**
   * 最下部 自動リロード
   */
  // TODO: 表示条件変更時に、表示完了の際に 検索結果はありません が出てしまう事がある
  async loadInfinite($state: any) {
    const loadedPurchaseItems: Purchase[] = await this.getPurchaseList30(
      this.searchOptions
    );

    // 表示するデータがあれば結合して末尾に追加、なければ終了
    if (loadedPurchaseItems.length) {
      if (this.purchaseItems.length == 0) {
        this.purchaseItems = loadedPurchaseItems;
      } else {
        this.purchaseItems = this.purchaseItems.concat(loadedPurchaseItems);
      }
      for (let i = 0; i < this.purchaseItems.length; i++) {
        this.printStatus.push(false);
      }

      $state.loaded();
    } else {
      $state.complete();
    }
  }

  async selectAll() {
    if (this.isAllSelected) {
      this.selectedIds = [];
      this.isAllSelected = false;
    } else {
      this.selectedIds = [];
      for (const item in this.purchaseItems) {
        this.selectedIds.push(this.purchaseItems[item].id);
      }
      this.isAllSelected = true;
    }
  }
  async select() {
    this.isAllSelected = this.selectedIds.length === this.purchaseItems.length;
  }

  disabledChangeStatus(item: Purchase): boolean {
    return (
      item.status === Status.Invalid || item.status === Status.ACTUAL_RESULT
    );
  }

  isNegative(value: number): boolean {
    return value < 0;
  }
}
